import React from 'react';
import {
    FilterFieldTypeEnum,
    guardFieldCheckboxListType,
    guardFieldCheckboxType,
    guardFieldRangeType
} from "../../../model/filter-types";
import SelectedItem from "./SelectedItem";
import {utilsTypeof} from "../../../../../shared/utils/utilsTypeof";
import {FilterSelectorsType, FilterStateType} from "../../../model/types";
import {OnChangeFilterHandler} from "../../../model/useFilterHandler";
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../../../app/styles/GlobalStyles";


const StyledWrapper = styled.div`
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
`

interface IProps {
    filtersSelector: FilterSelectorsType,
    filterState: FilterStateType,
    onChangeFilter: OnChangeFilterHandler,
}

const FilterSelectedRenderer = ({
                                    filtersSelector,
                                    onChangeFilter,
                                    filterState,
                                }: IProps) => {
    return (
        <StyledWrapper className={GLOBAL_STYLE_CONFIG.splitByPrefix('filter-selected-renderer')}>
            {Object.keys(filterState).map(keyField => {
                const selectedValues = filterState[keyField];
                const targetFieldSelector = filtersSelector?.[keyField] ?? null;
                if (!targetFieldSelector) return null;

                if (guardFieldCheckboxType(targetFieldSelector)) {
                    return (
                        <SelectedItem onUnSelected={() => onChangeFilter(false, keyField, FilterFieldTypeEnum.checkbox)}
                                      title={targetFieldSelector.title}
                        />
                    )
                }
                if (guardFieldCheckboxListType(targetFieldSelector)) {
                    if (Array.isArray(selectedValues)) {
                        return selectedValues.map((idKey) => {
                            return (<SelectedItem
                                onUnSelected={() => onChangeFilter(idKey, keyField, FilterFieldTypeEnum.checkbox_list)}
                                title={idKey.toString()}
                            />)
                        })
                    }
                    if (utilsTypeof.isValidString(selectedValues)) {
                        return (<SelectedItem
                            onUnSelected={() => onChangeFilter(selectedValues, keyField, FilterFieldTypeEnum.checkbox_list)}
                            title={selectedValues}
                        />)
                    }
                }

                if (guardFieldRangeType(targetFieldSelector)) {

                    if (Array.isArray(selectedValues)) {
                        const min = +selectedValues[0].toString().replace(">", "")
                        const max = +selectedValues[1].toString().replace("<", "")
                        return (<SelectedItem
                            onUnSelected={() => onChangeFilter([], keyField, FilterFieldTypeEnum.range)}
                            title={` ${min} - ${max}`}
                        />)
                    }
                }
            })}
        </StyledWrapper>
    );
};

export default FilterSelectedRenderer;